import { render, staticRenderFns } from "./ProjectActivity.vue?vue&type=template&id=77d5a06f&scoped=true"
import script from "./ProjectActivity.vue?vue&type=script&lang=js"
export * from "./ProjectActivity.vue?vue&type=script&lang=js"
import style0 from "./ProjectActivity.vue?vue&type=style&index=0&id=77d5a06f&prod&scoped=true&lang=css"
import style1 from "./ProjectActivity.vue?vue&type=style&index=1&id=77d5a06f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d5a06f",
  null
  
)

export default component.exports